import { Box, Typography, Button } from '@mui/material';
import { ExitToApp, Person } from '@mui/icons-material';
import { useAuth } from '../hooks/useAuth';

const ImpersonationBanner = () => {
    const { isImpersonating, user, leaveImpersonation } = useAuth();

    if (!isImpersonating) {
        return null;
    }

    const handleLeaveImpersonation = async () => {
        try {
            await leaveImpersonation();
        } catch (error) {
            console.error('Error leaving impersonation:', error);
        }
    };

    return (
        <Box
            sx={{
                bgcolor: '#eef6ff',
                borderBottom: '1px solid #b5d9fd',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                py: 1.5,
                px: 3,
                gap: 2,
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Person sx={{ color: '#416180', fontSize: 20 }} />
                <Typography variant="body2" sx={{ fontWeight: 500, color: '#1d2d3d' }}>
                    Estas personificando a <strong>{user?.name}</strong> ({user?.email})
                </Typography>
            </Box>
            <Button
                variant="outlined"
                size="small"
                startIcon={<ExitToApp />}
                onClick={handleLeaveImpersonation}
                sx={{
                    fontWeight: 600,
                    borderColor: '#b5d9fd',
                    color: '#1d2d3d',
                    '&:hover': {
                        borderColor: '#416180',
                        backgroundColor: 'rgba(89,128,166,0.07)',
                    },
                }}
            >
                Salir de Personificacion
            </Button>
        </Box>
    );
};

export default ImpersonationBanner;
